module.exports = __webpack_public_path__ + "static/forbes-437976f8392f780b813b2ec9851ace6c.png";